<template>
	<section class="small-12 rentListing propertyListingsPage" v-if="property">
		<section class="small-12 columns pageTitle flex justify-center">
			<div class="small-12 flex vertical-align">
				<div class="small-12 large-9 columns flex vertical-align">
					<h1 class="auto flex vertical-align">
						Lease Overview
					</h1>
					<ul class="auto float-left flex vertical-align crumbs">
						<li>
							<span class="round separator bgPrimaryBlue"></span>
						</li>
						<li>
							<p class="small-12 flex vertical-align" v-if="unit">
								<b>Unit:</b> 
								<router-link :to="{ name: 'Unit', params: { id: $route.params.id, unitID: unit.id } }" class="flex vertical-align borderRadius2">
									{{ unit.attributes.number }}
									<i class="material-icons border round">chevron_right</i>
								</router-link>
							</p>
						</li>
						<li>
							<p class="small-12 flex vertical-align" v-if="resident">
								<b>Resident:</b> 
								<router-link :to="{ name: 'Resident', params: { id: $route.params.id, residentID: resident.id } }" class="flex vertical-align borderRadius2">
									{{ resident.attributes.contact_information.first_name }} {{ resident.attributes.contact_information.last_name }}
									<i class="material-icons border round">chevron_right</i>
								</router-link>
							</p>
						</li>
					</ul>
				</div>
				<div class="small-12 large-3 columns searchContainer">
					<ul class="small-12 flex justify-right vertical-align">
						<li class="addMenu" v-if="user">
							<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openEditLeaseMenu()" v-if="lease">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">edit</i>
								Edit Lease
							</a>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<div class="small-12 flex listingsContainer">
			<section class="small-12 large-8 flex justify-center listings border-right listingsContainerWrap" v-bind:class="{ zIndex: set_index }">
				<div class="small-12 columns widgets">
					<ul class="small-12 float-left flex">
						<li class="small-12 columns">
							<lease-stats :rent="rent" :lease="lease"/>
						</li>
					</ul>
				</div>
				<div class="small-12 columns listingsTitle animated fadeIn">
					<div class="small-12 flex vertical-align">
						<h3 class="small-3 columns flex vertical-align">
							Rent Terms 
						</h3>
						<div class="small-9 columns searchContainer" style="margin-bottom:20px;">
							<ul class="small-12 flex justify-right vertical-align">
								<li class="reportsMenu">
									<a ref="rentFilters" class="flex justify-center vertical-align borderRadius4" @click="showFilterDropdownMenu()">
										<i class="material-icons-outlined chartIcon flex justify-center vertical-align borderRadius4">filter_alt</i>
										Filter
									</a>
									<div ref="rentFiltersMenu" class="auto filterDropdownMenu animated fadeIn" v-if="show_filter_menu_dropdown">
										<div class="small-12 filterWrap borderRadius4">
											<div class="small-12 filterMenuLabel">
												<p>Quick Filters</p>
											</div>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('current')">
												<i class="material-icons-outlined">book_online</i>
												Current Term
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('future')">
												<i class="material-icons-outlined">event</i>
												Future Terms
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="filterBy('past')">
												<i class="material-icons-outlined">restore_page</i>
												Past Terms
											</a>
											<a class="small-12 menuItem flex vertical-align" @click="viewAllListings()">
												<i class="material-icons-outlined">list</i>
												View All
											</a>
										</div>
									</div>
								</li>
								<li class="search small-12 large-3" @click="resetIndex($event)">
									<datetime :placeholder="'Search by Date'" v-model="search_query" value-zone="local" zone="local" :phrases="{ok: 'Select', cancel: 'Cancel'}" :format="{ month: 'numeric', day: 'numeric', year: 'numeric' }" @input="searchResults($event)"></datetime>
									<label class="borderRadius4 flex vertical-align transition">
										<i class="material-icons-outlined">search</i>
										Search by Date
									</label>
								</li>
								<li class="addMenu" v-if="user">
									<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddRentMenu()" v-if="user.relationships.company && lease && lease.type !== 'fixed' && !rent">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Rent Term
									</a>
									<a class="blueButton flex vertical-align justify-center borderRadius4" @click="openAddRentMenu()" v-else-if="user.relationships.company && !rent">
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
										Add Rent Term
									</a>
									<a class="flex whiteButton plain vertical-align justify-center borderRadius4 border" @click="showAddRentTermButtonInfo()" v-else>
										<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">info</i>
										Add Rent Term
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="small-12 columns listingsTable inPage animated fadeIn">
					<div class="small-12 columns head">
						<ul class="small-12 flex vertical-align">
							<li class="small-12 large-2 flex vertical-align">
								<p class="flex columns vertical-align">
									Term
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Start Date
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									End Date
								</p>
							</li>
							<li class="small-12 large-2 columns flex vertical-align end">
								<p class="flex vertical-align">
									Cycle
								</p>
							</li>
							<li class="small-12 large-4 columns flex vertical-align end">
								<p class="flex vertical-align">
									Amount
								</p>
							</li>
						</ul>
					</div>
					<div class="small-12 columns body">
						<div class="small-12" v-if="search_query">
							<div class="small-12 flex listingsDiv" v-if="queried_results.length > 0">
								<rent :rent="rent" :lease="lease" :company="company" v-for="(rent, index) in queried_results" :key="index" @openCreateInvoiceMenu="openCreateInvoiceMenu" @openViewInvoiceMenu="openViewInvoiceMenu" @openEditRentMenu="openEditRentMenu"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No rent terms have been found for that selection.
										</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="small-12" v-if="!search_query">
							<div class="small-12 flex listingsDiv" v-if="rents && rents.length > 0">
								<rent :rent="rent" :lease="lease" :company="company" v-for="(rent, index) in rents" :key="index" @openCreateInvoiceMenu="openCreateInvoiceMenu" @openViewInvoiceMenu="openViewInvoiceMenu" @openEditRentMenu="openEditRentMenu"/>
							</div>
							<ul class="small-12 columns flex animated fadeIn" v-else>
								<li class="small-12">
									<div class="small-12 emptyResults flex justify-center">
										<picture class="small-12 flex justify-center">
											<img width="120" :src="empty_image" alt="Nestd Logo in a House">
										</picture>
										<h6 class="small-12 text-center">
											0 results found
										</h6>
										<p class="small-12 text-center">
											No rent terms have been added to this lease yet.
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<user-footer/>
			</section>
			<section class="small-12 large-4 flex overviewPanel" v-bind:class="{ active: a_menu_is_open }">
				<div class="small-12 panelWrap" v-bind:class="{ active: a_menu_is_open }">
					<div class="small-12 companyNeeded borderRadius8 border" v-if="!user.relationships.company">
						<picture class="small-12 flex justify-center">
							<img :src="empty_company_image" alt="Company Vector">
						</picture>
						<h2 class="small-12 columns text-center">No Company Found</h2>
						<p class="small-12 columns text-center">Please set up your company first before adding rent to this lease.</p>
						<div class="small-12 action flex justify-center">
							<router-link :to="{ name: 'SettingsCompany' }" class="blueButton flex vertical-align justify-center borderRadius4">
								<i class="material-icons-outlined addIcon borderRadius4 flex justify-center vertical-align">add</i>
								Set Up Company
							</router-link>
						</div>
					</div>
					<div class="small-12 panelBody flex vertical-align" v-else>
						<lease-details :lease="lease"/>
					</div>
				</div>
				<edit-rent-menu ref="editRentMenu" :menu_action="open_edit_rent_menu" :rent="editing_rent" :company="company" :rents="rents" :property="property" :lease="lease" @closeEditRentMenu="closeEditRentMenu" @setCalendarPickerIndex="setCalendarPickerIndex"/>
				<add-rent-menu ref="addRentMenu" :menu_action="open_add_rent_menu" :rents="rents" :property="property" :lease="lease" :resident="resident" :unit="unit" :user="user" :company="company" @closeAddRentMenu="closeAddRentMenu" @setCalendarPickerIndex="setCalendarPickerIndex"/>
				<create-invoice-menu ref="createInvoiceMenu" :menu_action="open_create_invoice_menu" :property="property" :lease="lease" :resident="resident" :unit="unit" :user="user" :company="company" :rent="create_invoice_rent" @closeCreateInvoiceMenu="closeCreateInvoiceMenu" @setCalendarPickerIndex="setCalendarPickerIndex"/>
				<view-invoice-menu ref="viewInvoiceMenu" :menu_action="open_view_invoice_menu" :invoice="view_invoice" :resident="resident" :unit="unit" :company="company" :user="user" @closeViewInvoiceMenu="closeViewInvoiceMenu" @refreshInvoice="refreshInvoice"/>
				<edit-lease-menu ref="editLeaseMenu" :menu_action="open_edit_lease_menu" :lease="lease" :resident="resident" @closeEditLeaseMenu="closeEditLeaseMenu" @setCalendarPickerIndex="setCalendarPickerIndex"/>
			</section>
		</div>
	</section>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the events
	import { GetRentListings } from '@/events/rent/GetRentListings'
	import { GetRent } from '@/events/rent/GetRent'
	import { RefreshInvoice } from '@/events/invoices/RefreshInvoice'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LeaseDetails from '@/components/property/lease/shared/LeaseDetails.vue'
	import AddRentMenu from '@/components/property/lease/rent/AddRentMenu.vue'
	import Rent from '@/components/property/lease/rent/Rent.vue'
	import CreateInvoiceMenu from '@/components/property/lease/invoices/CreateInvoiceMenu.vue'
	import ViewInvoiceMenu from '@/components/property/lease/invoices/ViewInvoiceMenu.vue'
	import LeaseStats from '@/components/property/lease/rent/LeaseStats.vue'
	import EditRentMenu from '@/components/property/lease/rent/EditRentMenu.vue'
	import EditLeaseMenu from '@/components/property/lease/rent/EditLeaseMenu.vue'
	import { Datetime } from 'vue-datetime'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'RentListing',

		/*
		**  Register the components
		*/

		components: {

			UserFooter,
			LeaseDetails,
			AddRentMenu,
			Rent,
			CreateInvoiceMenu,
			ViewInvoiceMenu,
			UserFooter,
			LeaseStats,
			EditRentMenu,
			EditLeaseMenu,
			datetime: Datetime

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			GetRentListings,
			GetRent,
			RefreshInvoice

		],

		/*
		**  Set the props
		*/

		props: {

			property: {
				type: Object,
				default: () => null
			},
			user: {
				type: Object,
				default: () => null
			},
			resident: {
				type: Object,
				default: () => null
			},
			unit: {
				type: Object,
				default: () => null
			},
			lease: {
				type: Object,
				default: () => null
			},
			company: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			future_item: false,
			search_query: '',
			empty_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fnestd-logo-house.svg?alt=media&token=782a6239-e56b-4366-9ed5-b278ad5ea9e4',
			empty_company_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fempty-operations.svg?alt=media&token=1ee6789f-1ad3-4348-aeeb-539c8a687584',
			open_add_rent_menu: false,
			open_create_invoice_menu: false,
			create_invoice_rent: null,
			selected_rent: null,
			open_view_invoice_menu: false,
			view_invoice: null,
			a_menu_is_open: false,
			editing_rent: null,
			open_edit_rent_menu: false,
			queried_results: [],
			show_filter_menu_dropdown: false,
			open_edit_lease_menu: false,
			set_index: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					**  Get the rent docs
					**  @method: Events/Rent/GetRentListings
					*/

					if (lease) this.getRentListingsHandler();

					/*
					**  Get the current rent doc
					**  @method: Events/Rent/GetRent
					*/

					if (lease) this.getRentHandler(lease.relationships.active_rent);

				}

			}

		},

		/*
        ** Do this first
        */

        created() {

        	window.addEventListener('click', this.closeFilterMenu);

        },

		beforeDestroy() {

			window.removeEventListener('click', this.closeFilterMenu);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			openAddRentMenu: function() {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if (this.open_view_invoice_menu) this.$refs.viewInvoiceMenu.closeViewInvoiceMenu();
					if(this.open_create_invoice_menu) this.$refs.createInvoiceMenu.closeNewInvoiceMenu();
					if (this.open_edit_rent_menu) this.$refs.editRentMenu.closeEditRentMenu();
					if (this.open_edit_lease_menu) this.$refs.editLeaseMenu.closeEditLeaseMenu();

					/*
					**  Open the create rent menu
					**  @prop: @here
					*/

					this.open_add_rent_menu = true;

					/*
					**  Set the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the Create Rent Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'DpLazyXA9kFpLquyKGMx',
						error: e
					});

				}

			},

			closeAddRentMenu: function(value) {

				try {

					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_add_rent_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Create Rent Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'wM7DAZfBovOuZMpY5lLE',
						error: e
					});

				}

			},

			openCreateInvoiceMenu: function(value) {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if (this.open_view_invoice_menu) this.$refs.viewInvoiceMenu.closeViewInvoiceMenu();
					if (this.open_add_rent_menu) this.$refs.addRentMenu.closeMenu();
					if (this.open_edit_rent_menu) this.$refs.editRentMenu.closeEditRentMenu();
					if (this.open_edit_lease_menu) this.$refs.editLeaseMenu.closeEditLeaseMenu();
	
					/*
					**  Add to create invoice rent prop
					**  @prop: @here
					*/

					this.create_invoice_rent = value;

					/*
					**  Open the create invoice menu
					**  @prop: @here
					*/

					this.open_create_invoice_menu = true;

					/*
					**  Set the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the Create Invoice Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'UZAEGzFP2dh3UATzDG3z',
						error: e
					});

				}

			},

			closeCreateInvoiceMenu: function(value) {

				try {

					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_create_invoice_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Create Invoice Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'ZROeYsYxFywl5L6J7nTl',
						error: e
					});

				}

			},

			openViewInvoiceMenu: function(value) {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if(this.open_create_invoice_menu) this.$refs.createInvoiceMenu.closeNewInvoiceMenu();
					if (this.open_add_rent_menu) this.$refs.addRentMenu.closeMenu();
					if (this.open_edit_rent_menu) this.$refs.editRentMenu.closeEditRentMenu();
					if (this.open_edit_lease_menu) this.$refs.editLeaseMenu.closeEditLeaseMenu();

					/*
					**  Add to view invoice prop
					**  @prop: @here
					*/

					this.view_invoice = value;

					/*
					**  Open the view invoice menu
					**  @prop: @here
					*/

					this.open_view_invoice_menu = true;

					/*
					**  Set the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the View Invoice Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'Glv65SH7K39WqF7hIqQ4',
						error: e
					});

				}

			},

			closeViewInvoiceMenu: function() {

				try {

					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_view_invoice_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the View Invoice Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'uwNFboaXTsgr0dG7p3xS',
						error: e
					});

				}

			},

			refreshInvoice: function(value) {

				/*
				**  Refresh the rent invoice
				**  @method: Events/Invoices/RefreshInvoice
				*/

				if (value && value.id) this.refreshInvoiceHandler(value.id);

			},

			openEditRentMenu: function(value) {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if(this.open_create_invoice_menu) this.$refs.createInvoiceMenu.closeNewInvoiceMenu();
					if (this.open_add_rent_menu) this.$refs.addRentMenu.closeMenu();
					if (this.open_view_invoice_menu) this.$refs.viewInvoiceMenu.closeViewInvoiceMenu();
					if (this.open_edit_lease_menu) this.$refs.editLeaseMenu.closeEditLeaseMenu();

					/*
					**  Set the editing rent prop
					**  @prop: @here
					*/

					this.editing_rent = value;

					/*
					**  Open the modal
					**  @prop: @here
					*/

					this.open_edit_rent_menu = true;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the Edit Rent Term Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 't65TvAEUcnYpVddYJG1a',
						error: e
					});

				}

			},

			closeEditRentMenu: function() {

				try {

					/*
					**  Reset the editing rent prop
					**  @prop: @here
					*/

					this.editing_rent = null;

					/*
					**  Open the modal
					**  @prop: @here
					*/

					this.open_edit_rent_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Edit Rent Term Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'w81e86JifgsujgquSBeS',
						error: e
					});

				}

			},

			searchResults: function (event) {

				/*
				**  Reset the results
				**  @prop: @here
				*/

				this.queried_results = [];

				/*
				**  Filter the data
				*/

				if (event) {

					/*
					**  Set the vars
					*/

					let searchQuery = moment(this.search_query),
						isValid = searchQuery.isValid();

					if (this.rents.length > 0 && isValid) {

						return this.rents.filter((item)=>{

							let start_date = moment(item.attributes.term_dates.starting_at),
								end_date = moment(item.attributes.term_dates.ending_at),
								isBetween = moment(searchQuery).isBetween(moment(start_date * 1000), moment(end_date * 1000));

							if (isBetween) return this.queried_results.push(item);

						});

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.rents;

					}

				}

			},

			viewAllListings: function() {

				try {

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.search_query = '';

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to View All of the Rent Term Listings',
						errorType: 'Application',
						section: 'Rent',
						uid: 'f49owhPMKoDMsQk1G7by',
						error: e
					});

				}

			},

			showFilterDropdownMenu: function() {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					if (!this.show_filter_menu_dropdown) {

						this.show_filter_menu_dropdown = true;

					} else {

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to Show the Filter Dropdown Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'kH2Z6Mbs0zhEmhUX5SlZ',
						error: e
					});

				}

			},

			closeFilterMenu(evt) {

				try {

					let containsElement = this.$el.contains(evt.target),
						parentElement = evt.target.parentElement;

					/*
					**  If menu wasn't clicked
					*/

					if (evt.target !== this.$refs['rentFiltersMenu'] && evt.target !== this.$refs['rentFilters'] && parentElement !== this.$refs['rentFilters']) {

						/*
						**  Set the prop
						**  @prop: @here
						*/

						this.show_filter_menu_dropdown = false;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to close the rent filter menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'TU1hZ3M9rr7tPPjjlQiZ',
						error: e
					});

				}

		    },

			filterBy: function(value) {

				try {

					/*
					**  Set the search query
					**  @prop: @here
					*/

					this.search_query = value;

					/*
					**  Reset the results
					**  @prop: @here
					*/

					this.queried_results = [];

					/*
					**  Filter the results
					**  @prop: @here
					*/

					if (this.rents.length > 0 && value) {

						return this.rents.filter((item)=>{

							if (item.attributes.term.toLowerCase().includes(value.toLowerCase())) {

								return this.queried_results.push(item);

							}

						});

					} else {

						/*
						**  Set the full list of rents
						*/

						return this.queried_results = this.rents;

					}

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Unable to apply a rent filter when filtering rent terms.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'GVEiVwmS338XvSDborb3',
						error: e
					});

				}

			},

			openEditLeaseMenu: function() {

				try {

					/*
					**  Close the menus
					**  @props: @here
					*/

					if (this.open_view_invoice_menu) this.$refs.viewInvoiceMenu.closeViewInvoiceMenu();
					if(this.open_create_invoice_menu) this.$refs.createInvoiceMenu.closeNewInvoiceMenu();
					if (this.open_edit_rent_menu) this.$refs.editRentMenu.closeEditRentMenu();
					if (this.open_add_rent_menu) this.$refs.addRentMenu.closeMenu();

					/*
					**  Open the edit lease menu
					**  @prop: @here
					*/

					this.open_edit_lease_menu = true;

					/*
					**  Set the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Open the Edit Lease Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'fn13v1KvknAGZZkvdvbi',
						error: e
					});

				}

			},

			closeEditLeaseMenu: function(value) {

				try {

					/*
					**  Close the menu
					**  @prop: @here
					*/

					this.open_edit_lease_menu = false;

					/*
					**  Remove the active class on the lease details panel
					**  @prop: @here
					*/

					this.a_menu_is_open = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Close the Edit Lease Menu',
						errorType: 'Application',
						section: 'Rent',
						uid: 'XQ4HLnsHm1uc9UfAq5Vq',
						error: e
					});

				}

			},

			setCalendarPickerIndex: function(event) {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.set_index = true;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Set the calendar index.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'ExPYS1sge5Y4dVs699vp',
						error: e
					});

				}

			},

			resetIndex: function(event) {

				try {

					/*
					**  Set the prop
					**  @prop: @here
					*/

					this.set_index = false;

				} catch (e) {

					/*
					**  Send to Bugsnag
					**  @service: Bugsnag/BugsnagService
					*/
				
					this.reportAuthBugsnagError({
						title: 'Reset the calendar index.',
						errorType: 'Application',
						section: 'Rent',
						uid: 'pPV6v9B0Wwck86fgaDK6',
						error: e
					});

				}

			},

			showAddRentTermButtonInfo: function() {

                try {

					/*
                    **  Show the message
                    **  @service: @SweetAlert2
                    */

                    this.$swal('Unable to add a rent term.', 'A fixed lease can only have one rent term assigned to it.', 'info');

                } catch (e) {

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

                    this.reportAuthBugsnagError({
                        title: 'Show the delete button info modal.',
                        errorType: 'Application',
                        section: 'Edit Lease',
						uid: 'hdDQ6Wwo20pCpkbnMOAS',
                        error: e
                    });

                }

            }

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>